module.exports = __webpack_public_path__ + "img/制御工学3_3.29ecab08.png";